/**
 * Resource mutation event bus.
 *
 * Lookup caches (e.g. the account-form provider/license/cost-center
 * dropdowns) want to refetch only when *that* resource has been changed,
 * not on every form open. `dataProvider` emits an event whenever a
 * create / update / delete succeeds for a resource; interested modules
 * subscribe and invalidate their own caches keyed by resource name.
 *
 * Decoupled by design: `dataProvider` doesn't know about lookup keys,
 * and feature caches don't know about `dataProvider`.
 */

type ResourceListener = (resource: string) => void;

const listeners = new Set<ResourceListener>();

export const emitResourceMutated = (resource: string): void => {
  listeners.forEach((fn) => fn(resource));
};

export const subscribeResourceMutated = (
  listener: ResourceListener
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
